import React from "react"
import { Flex, Text, Stack } from "@chakra-ui/react"
import Icon from "components/elements/Icon"
import { SeatingAssignment } from "sharedTypes"

type Props = {
  seatingAssignment?: SeatingAssignment;
  standing?: boolean;
}

const SeatCell = ({ seatingAssignment, standing }: Props) => {
  if (seatingAssignment) {
    return (
      <Flex align="center">
        <Icon icon={`table-${seatingAssignment.shape}`} size={6} mr={2} />
        <Stack spacing={0}>
          <Text fontSize="sm" lineHeight={1} noOfLines={1}>
            {seatingAssignment.seatingTableTitle}
          </Text>
          <Text fontSize="xs" lineHeight={1} noOfLines={1} color="gray.700">
            Seat {seatingAssignment.seat}
          </Text>
        </Stack>
      </Flex>
    )
  }

  if (standing) {
    return (
      <Flex align="center">
        <Icon icon="invite-seat" size={4} mr={2} />
        <Text fontSize="sm">Standing</Text>
      </Flex>
    )
  }

  return null
}

export default SeatCell
